module.exports = __webpack_public_path__ + "static/location_vn-dfb5e0fa177e1c5b3ea40daf6bea181f.jpg";